import { Dispatch, Middleware } from 'redux';
import * as uniqid from 'uniqid';
import NotificationProduced from '../events/NotificationProduced';
import Notification, { NotificationType } from '../Notification';
import Event from '../Event';

export interface EventToNotification {
    type: string;
    notification: string | ((event: Event) => Notification[]);
    notificationType?: NotificationType;
    hasButton?: boolean;
}

// tslint:disable-next-line:typedef
const eventToNotification = (eventToNotificationConfig: EventToNotification[]): Middleware => () => (next: Dispatch<Event>) => (
    event: Event

    // tslint:disable:no-any
): any => {
    const notifications = mapToNotification(eventToNotificationConfig, event);
    return notifications.reduce(
        (result: {}, item: NotificationProduced) => {
            return {
                ...result,
                ...next(item)
            };
        },
        {
            ...next(event)
        }
    );
};

const mapToNotification = (eventToNotificationConfig: EventToNotification[], event: Event): NotificationProduced[] => {
    return eventToNotificationConfig.reduce((result: NotificationProduced[], config: EventToNotification) => {
        if (config.type === event.type) {
            let notification: Notification[];
            if (typeof config.notification === 'string') {
                notification = [
                    new Notification(uniqid(), {
                        message: config.notification,
                        notificationType: config.notificationType !== undefined ? config.notificationType : NotificationType.Error,
                        hasButton: config.hasButton === undefined ? false : config.hasButton
                    })
                ];
                return [...result, new NotificationProduced(notification[0])];
            } else {
                notification = config.notification(event);
                const arrayNotifications: NotificationProduced[] = [];
                notification.forEach(notificationItem => {
                    arrayNotifications.push(new NotificationProduced(notificationItem));
                });
                return [...result].concat(arrayNotifications);
            }
        }
        return result;
    }, []);
};
export default eventToNotification;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventToNotification.ts